export default "__VITE_ASSET__BVCHrzbA__"